import React from 'react';
import { 
  Box, 
  Text, 
  VStack, 
  HStack, 
  Badge, 
  useColorModeValue,
  AspectRatio,
  Flex
} from '@chakra-ui/react';
import { Cube } from '@phosphor-icons/react';
import ThreeDViewer from '../ThreeDViewer'; // Assuming ThreeDViewer is in components folder

const ThreeDPreviewSection = ({
  modelSrc,
  modelInfo,
  isUploaded,
  accentColor,
  isLoading,
  isMobile
}) => {
  const cardBg = useColorModeValue('bg.surface', 'bg.surface');
  const borderColor = useColorModeValue('border.default', 'border.default');
  const textColor = useColorModeValue('text.muted', 'text.muted');

  if (!modelSrc && !isUploaded) {
    return (
      <Flex 
        justify="center" 
        align="center" 
        minH={isMobile ? "150px" : "200px"} 
        border="2px dashed" 
        borderColor={borderColor} 
        borderRadius="md"
        bg={cardBg}
        p={isMobile ? 2 : 4}
      >
        <VStack spacing={isMobile ? 2 : 3}>
          <Cube size={isMobile ? 24 : 32} color={textColor} />
          <Text color={textColor} textAlign="center" fontSize={isMobile ? "xs" : "sm"}>
            Select a 3D model to see a preview here.
          </Text>
        </VStack>
      </Flex>
    );
  }

  return (
    <VStack spacing={isMobile ? 2 : 4} align="stretch">
      <AspectRatio ratio={16 / 9} w="100%">
        <Box 
          borderWidth="1px" 
          borderColor={borderColor} 
          borderRadius="md" 
          overflow="hidden"
          bg={cardBg}
        >
          <ThreeDViewer
            url={modelSrc}
            fileName={modelInfo?.name}
            fileExtension={modelInfo?.type?.toLowerCase()}
            width="100%"
            height="100%"
            showControls={true}
            autoRotate={!isUploaded} // Auto-rotate only for preview, not after upload
          />
        </Box>
      </AspectRatio>

      {modelInfo && (
        <HStack spacing={isMobile ? 2 : 3} justify="center" wrap="wrap">
          <Badge variant="subtle" colorScheme="purple" fontSize={isMobile ? "xs" : "sm"}>
            {(modelInfo.size / 1024 / 1024).toFixed(2)} MB
          </Badge>
          <Badge variant="subtle" colorScheme="teal" fontSize={isMobile ? "xs" : "sm"}>
            {modelInfo.type}
          </Badge>
        </HStack>
      )}

      {isUploaded && (
        <Text 
          textAlign="center" 
          color="green.500" 
          fontWeight="bold" 
          fontSize={isMobile ? "sm" : "md"}
        >
          3D Model Uploaded Successfully!
        </Text>
      )}
    </VStack>
  );
};

export default ThreeDPreviewSection;
